import dayjs from 'dayjs';

import { DEFER_UPDATE_DURATION, LAST_SYNC } from './constants';

export const getLastDeferUpdateDiff = () => {
  const lastSyncInStorage = localStorage.getItem(DEFER_UPDATE_DURATION);

  if (lastSyncInStorage) {
    const parsed = JSON.parse(lastSyncInStorage);
    const diff = dayjs().diff(dayjs(parsed), 'minute');
    return diff;
  }
  return null;
};

export const saveDeferUpdateTimeToLocalStorage = () => {
  localStorage.setItem(DEFER_UPDATE_DURATION, JSON.stringify(Date.now()));
};

export const clearDeferUpdateTime = () => {
  localStorage.removeItem(DEFER_UPDATE_DURATION);
};

export const saveSyncTimeToLocalStorage = () => {
  localStorage.setItem(LAST_SYNC, JSON.stringify(Date.now()));
};

export const syncHelper = () => {
  return {
    getLastDeferUpdateDiff,
    saveDeferUpdateTimeToLocalStorage,
    clearDeferUpdateTime,
  };
};
